module.exports = __webpack_public_path__ + "img/email-dark.69487cd4.svg";